<template>
  <div style="width: 100%">
    <div class="overflow-visible">
      <div v-if="buttonActivation && isMobileOnly && !searchActive">
        <i class="fa fa-search" style="color: white;" @click="activateSearch"></i>
      </div>
      <div class="d-flex align-items-center search-border" v-if="!buttonActivation || (buttonActivation && searchActive) || !isMobileOnly">
        <div class="input-group">
          <span class="input-group-prepend">
            <div class="input-group-text bg-white border-0"><i class="fa fa-search"></i></div>
          </span>
          <input ref="input" v-model="q" @focus="openAndFocus" @blur="close" @keyup="debounce(search, 500)" type="search" class="form-control pl-1 border-0" :placeholder="placeholder" :style="state=='searching'?'':'border-top-right-radius: 5px; border-bottom-right-radius: 5px;'">

          <span class="input-group-append ml-0">
            <span class="input-group-text bg-white border-0" v-if="state=='searching'"><img src="/images/loader.gif" class="d-inline-block" alt="Processing…" style="width: 25px; height: 25px;"/></span>
          </span>
        </div>
      </div>
      <div v-show="open" id="search-overlay" class="mt-1" :class="classes.searchOverlay">
        <div id="search-overlay-contents" class="search-shadow search-border" v-if="helpcenter_articles && helpcenter_articles.length > 0" @mouseover="hover = true" @mouseleave="hover = false">
          <div id="entry" v-for="helpcenter_article in helpcenter_articles" :key="helpcenter_article.id">
            <a :href="'/'+helpcenter_article.full_slug" class="hover-none bg-white p-3 d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <div class="d-flex flex-column align-items-start">
                  <div class="d-flex justify-content-start text-left align-items-center">
                    <p class="mb-0 text-dark font-family-sans hover-none" style="font-weight: 600;">{{ helpcenter_article.name }}</p>
                  </div>
                  <small class="text-muted" v-if="helpcenter_article.content && helpcenter_article.content.category">
                    <span class="text-left">
                      <a :href="'/'+helpcenter_article.content.category.full_slug" class="hover-none" style="color: #6E757C;">{{ helpcenter_article.content.category.name }}</a>
                    </span>
                  </small>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          <div v-if="state=='finished' && !searchModified" class="search-shadow">
            <div id="entry">
              <span class="hover-none bg-white p-3 d-flex justify-content-between align-items-center" style="border-radius: 5px;">
                <div class="d-flex align-items-center">
                  <div class="d-flex flex-column align-items-start">
                    <div class="d-flex justify-content-start text-left align-items-center">
                      <p class="mb-0 text-dark font-family-sans hover-none font-weight-normal">Sorry, nothing found for <b>{{ truncatedQ }}</b></p>
                    </div>
                  </div>
                </div>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobileOnly, isIOS } from 'mobile-device-detect';
import Vue from 'vue';

export default {
  props: {
    story: Object,
    classes: Object,
    buttonActivation: Boolean,
    placeholder: String
  },
  data() {
    return {
      helpcenter_articles: [],
      open: false,
      state: "finished",
      q: "",
      lastQ: "",
      xhr: null,
      hover: false, // need to track search contents hover so links are clickable before blur
      searchActive: false,
      timeoutID: null,
      searchModified: false
    };
  },
  computed: {
    isMobileOnly: function () { return isMobileOnly; },
    truncatedQ: function() {
      if (this.q.length > 10) {
        return this.q.substring(0, length) + suffix;
      } else {
        return this.q;
      }
    }
  },
  watch: {
    searchActive: function (val) {
      document.getElementById("help-center-title").style.display = val ? "none" : "block"
      document.getElementById("breadcrumb-search-hc").style.width = "100%";
    },
    q: function(val) {
      this.searchModified = true; // hide "no results" overlay immediately when changing the search query
    }
  },
  methods: {
    activateSearch() {
      this.searchActive=true;
      this.$nextTick(() => {
        this.$refs.input.focus();
      })
    },
    debounce (fn, delay) {
      clearTimeout(this.timeoutID)
      var args = arguments
      var that = this
      this.timeoutID = setTimeout(function () {
        fn.apply(that, args)
      }, delay)
    },
    openAndFocus(event) {
      if (isMobileOnly) {
        var element = $("#search-input-field");
        if (!element.length) {
          element = $("#breadcrumb-search-hc");
        }
        $("html,body").animate({
          scrollTop: element.offset().top - 50
        })
      }
      this.open = true;
      if (this.q && this.q==this.lastQ) return;
      this.search();
    },
    close() {
      if (!this.hover) {
        this.open = false;
      }

      this.cancelSearch();
    },

    clear() {
      this.q = "";
      this.cancelSearch();
      this.search();
    },
    cancelSearch() {
      if (this.xhr) {
        this.xhr.abort();
        this.xhr = undefined;
      }
    },
    search() {
      if (this.state == "searching") this.cancelSearch();
      if (this.q.length == 0) {
        this.helpcenter_articles = this.story.featured_articles;
        for (var i = 0; i < this.helpcenter_articles.length; ++i) {
          var category_id = this.helpcenter_articles[i].content.category;
          for (var j = 0; j < this.story.featured_categories.length; ++j) {
            if (this.story.featured_categories[j].uuid == category_id) {
              this.helpcenter_articles[i].content.category = this.story.featured_categories[j];
            }
          }
        }
        this.state = "finished";
        return;
      }

      this.state = "searching";

      this.xhr = $.ajax({
        type: "GET",
        url: "/help/search",
        data: { q: this.q },
        success: (data) => {
          this.helpcenter_articles = data.helpcenter_articles;
          this.lastQ = this.q;
          this.state = "finished";
          this.searchModified = false;
        },
        error: (e) => {
          console.log(e);
          this.state = "finished";
        },
      });
    },
  },
  filters: {
      truncate: function (text, length, suffix) {
          if (text.length > length) {
              return text.substring(0, length) + suffix;
          } else {
              return text;
          }
      },
  }
};
</script>

<style lang="scss" scoped>
#entry a:hover {
  background-color: #edeff0 !important;
}

a:hover .text-dark {color:black !important;}

input:focus,
textarea:focus,
button:focus {
  outline: none;
  box-shadow: none;
}

.input-group {
  &:focus-within {
    border-radius: 5px;
    border-color: #05f;
    box-shadow: 0 0 0 1px #768089;
  }
}

/* clears the 'X' from Internet Explorer */
input[type="search"]::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
input[type="search"]::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

/* clears the 'X' from Chrome */
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration {
  display: none;
}



#search-overlay {
  position: absolute;
  z-index: 20;
}


.search-border {
  border-style: solid;
  border-color: #BAC0C4;
  border-width: 1px;
  border-radius: 5px;
}

#search-overlay-contents {
  max-height: 50vh;
  overflow: hidden auto;
  border-radius: 5px;
}

.search-shadow {
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.1);
}

.bg-dark-transparent {
  background-color: rgba(69, 69, 69, 0.9);
}

</style>

<style>
#search-input-field {
  z-index: 20;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
  max-width: 500px;
  position: absolute;
}

@media screen and (min-width:720px) { /* desktop */
  .search-overlay-breadcrumb-hc {
    right: 24px;
  }

  #breadcrumb-search-hc {
    text-align: right;
    max-width: 200px;
  }
}

@media screen and (max-width:720px) { /* desktop */
  .search-overlay-breadcrumb-hc {
    right: 24px;
    left: 24px;
  }
}

.hover-none:hover {
  text-decoration: none;
}

</style>
